module.exports = __webpack_public_path__ + "static/media/Banner.01bafd2d.png";